<script lang="ts">
  import type { Page } from "state/page";
  import BottomActionBar from "./BottomActionBar.svelte";
  import { createMetadataQuery } from "state/queries/mimir";
  import { detailAltText } from "state/detailAltText";
  import { getRequiredFields } from "services/plugin-customization";
  import { selectImageAction } from "./selectImageAction";
  import { getCloseCallback } from "config";

  export let state: Extract<Page, { type: "DETAIL" }>;

  const requiredFields = getRequiredFields();
  const altTextRequired = requiredFields && requiredFields.includes("altText");

  $: itemSource = state.itemSource ?? "Bildebanken";
  $: imageQuery = createMetadataQuery(state.itemId, itemSource);
  $: image = $imageQuery.isSuccess ? $imageQuery.data : undefined;

  // altText hentes fra detailAltText-storen, som oppdateres av Detail/index.svelte når queryen fullføres.
  // Ved navigering mellom bilder kan storen midlertidig inneholde altText fra forrige bilde.
  // Vi gater derfor på isSuccess slik at altText er undefined mens queryen lastes,
  // og unngår at et bilde feilaktig fremstår som valgbart.
  $: altText = $imageQuery.isSuccess ? $detailAltText : undefined;
  $: hasAltText = !!altText?.trim();

  let imageSelected = false;
  $: disabled =
    imageSelected ||
    (itemSource !== "Ntb" && !image) ||
    (!!altTextRequired && !hasAltText) ||
    image?.mediaType === "image/tiff";

  async function onAction() {
    imageSelected = true;
    try {
      await selectImageAction({ itemId: state.itemId, itemSource, image, altText });
    } finally {
      imageSelected = false;
    }
  }
</script>

<BottomActionBar
  label="Bruk bilde"
  {onAction}
  {disabled}
  busy={imageSelected}
  secondaryLabel="Avbryt"
  secondaryOnAction={getCloseCallback()}
/>
